// src/i18n.js
import { createI18n } from 'vue-i18n';
import en from './en.json';
import es from './es.json';
import eu from './eu.json';
import cat from './cat.json';


const messages = {
  en,
  es,
  eu,
  cat
};

const i18n = createI18n({
  legacy: false, // usamos la Composition API
  locale: 'es', // idioma por defecto
  fallbackLocale: 'en',
  messages,
});

export default i18n;